import _ from 'lodash'

export default function checkoutInProgress(props = {}) {
  const t = _.get(props, 't')
  const onCancel = _.get(props, 'onCancel')
  return {
    title: t('ui.paymentInProgressNonCheckoutOperatorModal.title'),
    message: t('ui.paymentInProgressNonCheckoutOperatorModal.description'),
    buttons: _.compact([
      {
        text: t('ui.paymentInProgressNonCheckoutOperatorModal.buttons.cancel'),
        onClick: onCancel,
      },
    ]),
  }
}
